export default function Card({ title, pad = true, as: Tag = 'div', className = '', children, ...rest }) {
  return (
    <Tag className={`cn-card ${pad ? 'cn-card--pad' : ''} ${className}`.trim()} {...rest}>
      {title && <h3 className="cn-card-title">{title}</h3>}
      {children}
    </Tag>
  )
}
